import Alerts_icon from "../../images/navbar/alert_icon.svg";
import Dashboard_icon from "../../images/navbar/dashboard_icon.svg";
import Driver_icon from "../../images/navbar/driver_icon.svg";
import ManageData_icon from "../../images/navbar/manageData_icon.svg";
import Route_icon from "../../images/navbar/route_icon.svg";
import Schedule_icon from "../../images/navbar/schedule_icon.svg";
import Site_icon from "../../images/navbar/sites_icon.svg";
import Stop_icon from "../../images/navbar/stop_icon.svg";
import User_icon from "../../images/navbar/users_icon.svg";
import Vehicle_icon from "../../images/navbar/vehicle_icon.svg";
import Add_icon from "../../images/navbar/navbar_dropdown/add_icon.svg"
import View_Icon from "../../images/navbar/navbar_dropdown/view_all_icon.svg"
import Vehicle_nav_icon from "../../images/navbar/navbar_dropdown/vehicle.svg"
import Users_nav_icon from "../../images/navbar/navbar_dropdown/user.svg"
import Due_dates_icon from "../../images/navbar/navbar_dropdown/duedates.svg"
import User_Roles_icon from "../../images/navbar/navbar_dropdown/user_roles.svg"
import Data_backup_icon from "../../images/navbar/navbar_dropdown/databackup.svg"
import Import_icon from "../../images/navbar/navbar_dropdown/import.svg"
import Delete_Data_icon from "../../images/navbar/navbar_dropdown/delete.svg"
import org_icon from "../../images/navbar/Organization_icon.svg";
import feature_icon from "../../images/navbar/feaure_icon.svg";

import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import axios from 'axios';
import config from '../../config';
import { useUser } from "../../pages/login/UserContextPersistent";

export const useNavData = () => {
    const navigate = useNavigate();
    const [vehicleData, setVehicleData] = useState([]);
    const [stopsData, setStopsData] = useState([]);

    // Get organization data from local storage
    const orgData = localStorage.getItem('userState');
    const parsedOrgData = JSON.parse(orgData);
    const orgId = parsedOrgData?.user?.organizationId;
    const orgName = parsedOrgData?.user?.name;
    console.log(orgId, orgName)

    // Fetch vehicle and stops data on component mount
    useEffect(() => {
        const fetchData = async () => {
            try {
                // Fetch vehicle data
                const vehicleResponse = await axios.get(
                    `${config.baseURL}/vehicle/organization`,
                    { withCredentials: true }
                );

                if (Array.isArray(vehicleResponse.data)) {
                    setVehicleData(vehicleResponse.data);
                } else {
                    console.error("Unexpected vehicle data format: expected array", vehicleResponse.data);
                }

                // Fetch stops data
                const stopsResponse = await axios.get(
                    `${config.baseURL}/stop/organization`,
                    { withCredentials: true }
                );

                if (Array.isArray(stopsResponse.data)) {
                    setStopsData(stopsResponse.data);
                } else {
                    console.error("Unexpected stops data format: expected array", stopsResponse.data);
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };

        fetchData();
    }, []);

    // Function to handle navigation with data
    const handleTrackAllVehicles = () => {
        navigate("/vehicle/TrackAllVehicle", {
            state: { allVehicleData: vehicleData }
        });
    };

    // Function to handle navigation with stops data
    const handleViewAllStopsOnMap = () => {
        navigate("/stop/all/map", {
            state: { allStopsData: stopsData }
        });
    };

    const NewNavData = [
        {
            path: "/dashboard",
            icon: <img src={Dashboard_icon} alt="Dashboard" />,
            label: "Dashboard",
            requiredFeature: "", // Dashboard is accessible to all
        },
        {
            path: "/Vehicle",
            icon: <img src={Vehicle_icon} alt="Vehicle" />,
            label: "Vehicles",
            requiredFeature: "/api/vehicle",
            subItems: [
                {
                    path: "/vehicle/add",
                    icon: <img src={Add_icon} alt="Add Icon" />,
                    label: "Create Vehicles",
                    requiredFeature: "/api/vehicle",
                    onClick: null,
                },
                {
                    path: "/vehicle/TrackAllVehicle",
                    icon: <img src={View_Icon} alt="Add Icon" />,
                    label: "Track Vehicles",
                    requiredFeature: "/api/vehicle",
                    onClick: handleTrackAllVehicles,
                }

            ]
        },
        {
            path: "/route",
            icon: <img src={Route_icon} alt="Route" />,
            label: "Routes",
            requiredFeature: "/api/route",
            subItems: [

                {
                    path: "/route/add",
                    icon: <img src={Add_icon} alt="Add Icon" />,
                    label: "Create Routes",
                    requiredFeature: "/api/route",
                },
                {
                    path: "/route/allroutes",
                    icon: <img src={View_Icon} alt="Add Icon" />,
                    label: "View All Routes",
                    requiredFeature: "/api/route",
                }
            ]
        },
        {
            path: "/stop",
            icon: <img src={Stop_icon} alt="Stops" />,
            label: "Stops",
            requiredFeature: "/api/stop",
            subItems: [

                {
                    path: "/stop/add",
                    icon: <img src={Add_icon} alt="Add Icon" />,
                    label: "Create Stops"
                },
                {
                    path: "/stop/all/map",
                    icon: <img src={View_Icon} alt="Map Icon" />,
                    label: "View All Stops",
                    onClick: handleViewAllStopsOnMap
                }
            ]
        },
        {
            path: "/alert",
            icon: <img src={Alerts_icon} alt="Alerts" />,
            label: "Alerts",
            requiredFeature: "/api/alert",
            // subItems: [
            //     {
            //         path: "/alert-new",
            //         icon: <img src={Vehicle_nav_icon} alt="Alert History" />,
            //         label: "Vehicles"
            //     },
            //     {
            //         path: "/alert-new",
            //         icon: <img src={Users_nav_icon} alt="Alert History" />,
            //         label: "Users"
            //     },
            //     {
            //         path: "/alert-new",
            //         icon: <img src={Due_dates_icon} alt="Alert History" />,
            //         label: "Due-dates"
            //     }
            // ]
        },
        {
            path: "/schedule",
            icon: <img src={Schedule_icon} alt="Schedule" />,
            label: "Schedule",
            requiredFeature: "/api/schedule",
            subItems: [

                {
                    path: "/schedule/add",
                    icon: <img src={Add_icon} alt="Add Icon" />,
                    label: "Create Schedules"
                }
            ]
        },
        {
            path: "/driver",
            icon: <img src={Driver_icon} alt="Driver" />,
            label: "Drivers",
            requiredFeature: "/api/driver",
            subItems: [
                {
                    path: "/driver/add",
                    icon: <img src={Add_icon} alt="Driver Schedule" />,
                    label: "Create Driver"
                }
            ]
        },
        {
            path: "/site",
            icon: <img src={Site_icon} alt="Site" />,
            label: "Sites",
            requiredFeature: "/api/site",
            subItems: [
                {
                    path: "/site",
                    icon: <img src={Add_icon} alt="Site Management" />,
                    label: "Add Sites"
                }
            ]
        },
        {
            path: "/user",
            icon: <img src={User_icon} alt="Users" />,
            label: "Users",
            requiredFeature: "/api/user",
            subItems: [

                {
                    path: "/user/AddUser",
                    icon: <img src={Add_icon} alt="User Roles" />,
                    label: "Create User"
                },
                // {
                //     path: "/User/role",
                //     icon: <img src={User_Roles_icon} alt="User Roles" />,
                //     label: "User Roles"
                // },
                {
                    path: "/user/role",
                    icon: <img src={Add_icon} alt="User Roles" />,
                    label: "Create Roles"
                }
            ]
        },
        ...(orgId === 5 && orgName === 'RouteEye Admin' ?
            [{
                path: "/org",
                icon: <img src={org_icon} alt="Organization" />,
                label: "Organization",
            }, {
                path: '/feature',
                icon: <img src={feature_icon} alt="features" />,
                label: "Features",
            }]
            : []),
        {
            path: "/managedata",
            icon: <img src={ManageData_icon} alt="Manage Data" />,
            label: "Manage Data",
            requiredFeature: "/api/manageData",
            subItems: [
                {
                    path: "/managedata",
                    icon: <img src={Data_backup_icon} alt="Import Data" />,
                    label: "Data Backup"
                },
                // {
                //     path: "/managedata",
                //     icon: <img src={Import_icon} alt="Export Data" />,
                //     label: "Import/Export"
                // },
                // {
                //     path: "/managedata",
                //     icon: <img src={Delete_Data_icon} alt="Export Data" />,
                //     label: "Delete Data"
                // }
            ]
        },
        // You can add Features menu item here if needed
        // {
        //     path: "/feature-new",
        //     icon: <img src={Feature_icon} alt="Features" />,
        //     label: "Features",
        //     requiredFeature: "/api/feature",
        // },
    ];
    return NewNavData;
};

export const useFilteredNavData = (pathname) => {
    const NewNavData = useNavData();
    const { state } = useUser();

    // Enhanced permission checking function that can check for specific actions
    const hasPermission = (requiredPath, requiredAction = null) => {
        // If no features found or no path required, allow access
        if (!state?.features || !requiredPath) {
            return true;
        }

        // Check if the user has the required permission
        return state.features.some(feature => {
            // Check if the API path matches
            const pathMatches = feature.api_path.includes(requiredPath);

            // If action is specified, check that too, otherwise just check the path
            return requiredAction ?
                (pathMatches && feature.action === requiredAction) :
                pathMatches;
        });
    };

    // Define permission requirements for main items and subitems
    const permissionMap = {
        // Main items
        "/dashboard": { path: "", action: null }, // Accessible to all
        "/Vehicle": { path: "/api/vehicle", action: null },
        "/route": { path: "/api/route", action: null },
        "/stop": { path: "/api/stop", action: null },
        "/alert": { path: "/api/alert", action: null },
        "/schedule": { path: "/api/schedule", action: null },
        "/user": { path: "/api/user", action: null },
        "/managedata": { path: "/managedata", action: null },
        "/site": { path: "/site", action: null },
        "/driver": { path: "/driver", action: null },

        // Subitems
        "/vehicle/add": { path: "/api/vehicle", action: "POST" },
        "/vehicle/TrackAllVehicle": { path: "/api/vehicle/organization", action: "GET" },
        "/route/add": { path: "/api/route", action: "POST" },
        "/route/allroutes": { path: "/api/route/organization", action: "GET" },
        "/stop/add": { path: "/api/stop", action: "POST" },
        "/stop/all/map": { path: "/api/stop/organization", action: "GET" },
        "/schedule/add": { path: "/api/schedule", action: "POST" },
        "/user/AddUser": { path: "/api/user", action: "POST" },
        "/user/role": { path: "/api/role", action: "POST" }
    };

    // Check if current path is an organization path
    const isOrganizationPath = [
        "/organization/add",
        "/AddOrganization",
        "/Organization"
    ].includes(pathname);

    let filteredData;

    if (isOrganizationPath) {
        // Keep only specific items for organization paths
        filteredData = NewNavData.filter(item => {
            const permission = permissionMap[item.path] || { path: "", action: null };
            return ["/dashboard", "/user", "/managedata", "/alert"].includes(item.path) &&
                hasPermission(permission.path, permission.action);
        });
    } else {
        // Filter main nav items first
        filteredData = NewNavData.filter(item => {
            const permission = permissionMap[item.path] || { path: "", action: null };
            return hasPermission(permission.path, permission.action);
        });

        // Then process each item to filter its subitems
        filteredData = filteredData.map(item => {
            // If item has no subitems, return it as is
            if (!item.subItems || !Array.isArray(item.subItems)) {
                return item;
            }

            // Filter the subitems
            const filteredSubItems = item.subItems.filter(subItem => {
                const permission = permissionMap[subItem.path];

                // If subitem is not in permission map, inherit from parent
                if (!permission) {
                    const parentPermission = permissionMap[item.path] || { path: "", action: null };
                    return hasPermission(parentPermission.path, parentPermission.action);
                }

                return hasPermission(permission.path, permission.action);
            });

            // Return the item with filtered subitems
            return {
                ...item,
                subItems: filteredSubItems
            };
        });
    }

    return filteredData;
};

